'use strict';
/* global $ */

window.Stat = {

    push: function(event_type, fg) {
        // console.log(`event_type: ${event_type}; fg: ${fg}`);
        var data = {
            location: window.location.href,
            event: event_type,
            fg: fg,
        };

        $.post('/api/stat', data);
        //   .done(function(response) { console.log(response); });
    },
};
